<template>
  <div class="quick-filter-wrapper" data-test-id="quick-filter-wrapper">
    <div class="scroll-container">
      <slot />
      <div class="actions">
        <button
          class="apply-button"
          data-test-id="quick-filter-apply"
          @click="handleApplyChanges"
        >
          Done
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { APPLY_QUICK_FILTER_PUBSUB } from '@/lib/multi-activity-experience'
import pubsub from '@/lib/pubsub'

const handleApplyChanges = () => {
  pubsub.publish(APPLY_QUICK_FILTER_PUBSUB)
}
</script>

<style lang="scss" scoped>
@use '@/styles/system/_type.scss';

.quick-filter-wrapper {
  width: 100%;
  background-color: var(--ys-color-background-primary);
  box-shadow:
    0px 2px 16px 0px rgba(0, 0, 0, 0.12),
    0px 7px 10px 0px rgba(0, 0, 0, 0.14),
    0px 4px 5px 0px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  :deep(.slider-container) {
    border: none !important;
  }
}

.scroll-container {
  background-color: var(--ys-color-background-primary);
  overflow-y: auto;
  max-height: 75vh;
  border-radius: 10px;
  padding: 0 var(--ys-spacing-250) var(--ys-spacing-200);
}

.actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: var(--ys-spacing-250);
  width: 100%;
  padding-top: var(--ys-spacing-250);
  button {
    @include type.button2Type;
    padding: var(--ys-spacing-150);
    background: none;
    &.apply-button {
      color: var(--ys-color-brand-primary);
    }
  }
}
</style>
